import React from "react";

import { Button } from "Components/Button";

import { InputCep } from "Components/Form/InputCep";
import { ContainerForm, Container } from "./styles";
import { useValidationCepRange } from "./useValidationCepRange";
import { ScheduleList } from "../ScheduleList";

export const ValidationRangeCep = () => {
  const {
    onSubmit,
    handleChange,
    zipcode,
    error,
    handleClear,
    loadingSchedule,
    scheduleData,
    schedulSuccess,
    isError,
    errorSchedule,
  } = useValidationCepRange();

  return (
    <Container className="wrapper-form">
      <ContainerForm
        onSubmit={onSubmit}
        className={`search-wrapper ${loadingSchedule ? "-waiting" : ""} `}
      >
        <div className="search-bar">
          <InputCep
            label=""
            id="cep"
            mask="99999-999"
            value={zipcode}
            onChange={handleChange}
            placeholder="Insira o seu CEP"
          />
          <button
            type="submit"
            className="button button-search"
            disabled={loadingSchedule}
          >
            <i className="icon-loupe" />
          </button>
        </div>

        <div className="wrap-text">
          {!!error && <p className="message message__14px _error">{error}</p>}

          {isError && (
            <>
              <Button onClick={handleClear} type="button">
                Tentar outro cep
              </Button>
            </>
          )}
        </div>

        <div className="schedule-sec">
          {errorSchedule && (
            <p className="text-center text-centered text-purple schedule-searching text-md">
              {" "}
              {errorSchedule.message}
            </p>
          )}

          {loadingSchedule ? (
            <p className="text-center text-centered text-purple schedule-searching text-md">
              Estamos buscando a agenda disponível, aguarde !
            </p>
          ) : null}

          {!loadingSchedule && !scheduleData && schedulSuccess && (
            <div>
              <p className="text-center text-centered text-purple schedule-searching text-md">
                Não há agenda disponível
              </p>
            </div>
          )}

          {!loadingSchedule && scheduleData?.length && (
            <div>
              <p className="text-left text-purple schedule-searching text-md">
                {scheduleData?.length > 1
                  ? "Agendas disponíveis:"
                  : "Agenda disponível:"}
              </p>
              <ScheduleList schedulesList={scheduleData} />
            </div>
          )}
        </div>
      </ContainerForm>
    </Container>
  );
};
